function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.69 2.69)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#000",
  strokeWidth: 1.75,
  transform: "rotate(45 13.127 13.127)",
  x: 4.039,
  y: 4.039,
  width: 18.176,
  height: 18.176,
  rx: 2.02
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.282 16.884v-2.457a3.03 3.03 0 013.03-3.03h3.028",
  stroke: "#000",
  strokeWidth: 1.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.779 14.064l3.177-2.294a.505.505 0 000-.82l-3.177-2.293a.505.505 0 00-.8.409v4.589a.505.505 0 00.8.409z",
  fill: "#000"
}));

function SvgUiNavigation32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgUiNavigation32;